import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import SearchMobile from './Header/SearchMobile'
import parse from 'html-react-parser';
import { decode } from 'html-entities';
import { NavigationContext } from './Contexts/NavigationContext';

const urlReplace = (url) => {
	return url.replace('https://blackoctopus-sound.infinitelabyrinth.com','').replace(window.location.origin, '');
}
export const NavigationLink = ({url,title,icon,toggle}) => {
	if(url.includes('/gold')) {
		return <Link to={{ pathname: urlReplace(url) }} onClick={toggle}>{icon && parse(icon)} { decode(title) }</Link>
	} else {
		return <a href={url} onClick={toggle}>{icon && parse(icon)} { decode(title) }</a>
	}
}
const NavigationItem = ({id, className, url, title, items, icon, toggle}) => (
	<li id={"menu-item-"+id} className={"menu-item "+className}>
		<NavigationLink url={url} title={title} icon={icon} toggle={toggle} />
		{items && items.length > 0 &&  <ul className="sub-menu"><NavigationSubmenu items={items} toggle={toggle} /></ul>}
	</li>
)
const NavigationSubmenu = ({items,toggle}) => {
	return(  
		<React.Fragment>{items.map(item => (
			<NavigationItem key={item.id} id={item.id} url={urlReplace(item.url)} title={item.title} items={item.children} icon={item.icon} toggle={toggle} />
		))}</React.Fragment>
	)
}
const NavigationParentItem = ({id, className, url, title, items, children, focus, hover, hovered, toggle }) => {
	const [delayHandler, setDelayHandler] = useState(null)
    const handleMouseEnter = event => {
        setDelayHandler(setTimeout(() => {
            hover(id)
        }, 50))
    }
    const handleMouseLeave = () => {
        hover(null)
        clearTimeout(delayHandler)
    }
    const containerRef = useRef();
   	let position = { left:0, width:100 }
   	if(containerRef.current) { position = containerRef.current.getBoundingClientRect(); }
	let style = {}
	if(className.includes('megamenu')) {
		style = { backgroundPositionX: position.left + ( position.width / 2 ) - 64 }; 
	} else {
		/*style = { marginLeft: (( position.width / 2 ) - 64 + 9) };*/
	}
	return(
		<li id={id} ref={containerRef} className={"menu-item "+(items ? 'menu-item-has-children ' : '')+className} onMouseEnter={ handleMouseEnter } onMouseLeave={ handleMouseLeave } onClick={() => {focus(id)}}>
			<NavigationLink url={url} title={title} toggle={toggle} />
			{items.length > 0 && <ul className={hovered ? "sub-menu visible" : "sub-menu"} style={style} onClick={ handleMouseLeave }><NavigationSubmenu items={items} toggle={toggle} /></ul>}
		</li>
	)
}

/*
export default function Navigation() {


}
*/
class Navigation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			toggled: false,
			focused: null,
			hovered: null,
		};
		this.toggle = this.toggle.bind(this);
		this.focus = this.focus.bind(this);
		this.hover = this.hover.bind(this);
	}
	focus(id) {
		if(this.state.focused === id) {
			this.setState({focused: null})
		} else {
			this.setState({focused: id})
		}
	}
	toggle() {
		if( !this.state.toggled ) {
			document.body.classList.add('menu-open');
		} else {
			document.body.classList.remove('menu-open');
		}
		this.setState({ toggled: !this.state.toggled })
	}
	hover(id) {
		const _this = this;
		if(this.state.hovered === id) {
			//this.setState({hovered: null})
		} else {
			setTimeout( function() { _this.setState({hovered: id}) }, 100 )
		}
	}
	render() {
		const nav = this.context;
		const articles = nav['articles'] && nav['articles'].menu;
		const items = nav['menu-1'].menu.items;
		const {toggled, focused, hovered} = this.state
		
		return (
			<React.Fragment>
			<nav id="site-navigation" className={"main-navigation "+(toggled ? 'toggled' : '')}>
				<SearchMobile />
				<div className="menu-regular-menu-new-container">
					<ul id="primary-menu" 
						className="menu nav-menu" 
						//aria-expanded="false"
						>
						
						{articles && <NavigationParentItem key={articles.ID} id={articles.ID} 
							className={"mobile-only "+(focused === articles.ID ? " focus" : "") } 
							url={articles.slug} 
							title={articles.name} 
							items={(focused === articles.ID) ? articles.items : []} 
							focus={this.focus}
							hover={this.hover}
							hovered={(hovered === articles.ID ? true : false)} 
						></NavigationParentItem>}

						{items.map((item,inx) => { 
							if(item.children) {
								return (
									<NavigationParentItem key={inx} id={item.id} 
										className={item.classes + (focused === item.id ? " focus" : "") } 
										url={item.url} 
										title={item.title} 
										items={(focused === item.id || hovered === item.id) ? item.children : []} 
										focus={this.focus}
										hover={this.hover}
										hovered={(hovered === item.id ? true : false)} 
										toggle={this.toggle}
									></NavigationParentItem>
								)
							}
							else { 
								return <li key={inx} className={item.classes+" menu-item"}><NavigationLink url={item.url} title={item.title} toggle={this.toggle} /></li> 
							}
						})}
					</ul>
				</div>
			</nav>
			<button className="menu-toggle" onClick={this.toggle} aria-controls="primary-menu" aria-expanded="false">Menu</button>
			<button className="mobile-search-toggle" onClick={this.toggle} aria-controls="" aria-expanded="false">Search</button>
			</React.Fragment>
		)
	}
}
Navigation.contextType = NavigationContext;
export default Navigation;